import React, { useEffect, useState, useContext } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
  Form,
  Input,
  FormFeedback,
} from "reactstrap";
import Select from "react-select";
import {
  resourcesGeofence,
  resourcesRoutes,
} from "../../../helpers/backend_helper";
import { getStorageCompany } from "../../../helpers/api_helper";
import { Alert, ToastHelper } from "../../../helpers/alerts/alertHelper";
import Validate from "./Validate";

import { useFormik } from "formik";
import * as Yup from "yup";
import classNames from "classnames";
import NibbleInput from "../../../components/Fields/NibbleInput";

const AddUpdModal = ({
  modal,
  setModal,
  items,
  setItems,
  setItem,
  item,
  authUser,
}) => {
  const company = getStorageCompany();
  const [errors, setErrors] = useState([]);
  const [routes, setRoutes] = useState([]);
  const [loading, setLoading] = useState(false);
  const handleClose = () => {
    setModal({ ...modal, show: false, update: false });
    setItem({
      ...item,
    });
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: { ...item },
    validationSchema: Yup.object({
      numero: Yup.string().nullable(true).required("Requerido"),
      name: Yup.string().nullable(true).required("Requerido"),
      alias: Yup.string().nullable(true).required("Requerido"),
      route_id: Yup.number().nullable(true).required("Requerido"),
      time_before: Yup.number().nullable(true).required("Requerido"),
      time_after: Yup.number().nullable(true).required("Requerido"),
      tipo: Yup.string().nullable(true).required("Requerido"),
    }),
    onSubmit: async (values) => {
      await save(values);
    },
  });

  useEffect(() => {
    if (authUser.profile_id != 3) {
      resourcesRoutes("get", {}).then((response) => {
        setRoutes(response.data);
      });
    }
  }, []);

  const save = async (data) => {
    try {
      setLoading(true);
      const response = modal.update
        ? await resourcesGeofence("put", data, data.id)
        : await resourcesGeofence("post", data);
      responseAction(response);
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  const responseAction = (response) => {
    if (response.status) {
      const newItem = response.geofence;
      let array = [];
      if (modal.update) {
        array = items.map((item) => (item.id !== newItem.id ? item : newItem));
      } else {
        array = [...items, newItem];
        array.sort((a, b) => {
          return a.id - b.id;
        });
      }
      setItems(array);
      handleClose();
      setLoading(false);
    } else {
      setLoading(false);
      setErrors(response.response.data.errors);
    }
  };

  return (
    <div>
      <Modal isOpen={modal.show}>
        <ModalHeader className="bg-primary">
          {modal.update ? "Editar Geocerca" : "Nueva Geocerca"}
        </ModalHeader>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
            return false;
          }}
        >
          <ModalBody>
            <div className="row">
              {authUser.profile_id == 2 && (
                <NibbleInput
                  md={12}
                  label="Ruta:"
                  fieldName="ruta"
                  fieldType="select"
                  selectItems={routes ?? []}
                  validation={validation}
                  selectOptionLabel={(option) => `${option.name}`}
                  selectOptionValue={(option) => option.id}
                />
              )}
              <NibbleInput
                md={6}
                label="Número:"
                fieldName="numero"
                fieldType="number"
                validation={validation}
              />

              <div className="col-sm-6"></div>

              <NibbleInput
                md={6}
                label="Nombre:"
                fieldName="name"
                fieldType="tesxt"
                validation={validation}
              />

              <NibbleInput
                md={6}
                label="Nombre corto:"
                fieldName="alias"
                maxLength="10"
                fieldType="text"
                validation={validation}
              />

              <NibbleInput
                md={6}
                label="Ajuste Tiempo Antes:"
                fieldName="time_before"
                fieldType="number"
                validation={validation}
              />

              <NibbleInput
                md={6}
                label="Ajuste Tiempo Despues:"
                fieldName="time_after"
                fieldType="number"
                validation={validation}
              />

              <NibbleInput
                md={6}
                label="Tipo:"
                fieldName="tipo"
                fieldType="radios"
                validation={validation}
                radioOptions={[
                  { label: "Geocerca", value: "geocerca" },
                  { label: "Ruta", value: "ruta" },
                ]}
                defaultRadioChecked={validation.values.tipo}
              />
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" type="submit" disabled={loading}>
              {loading && <Spinner size="sm"></Spinner>}{" "}
              <i className="fa fa-save"></i> Guardar
            </Button>{" "}
            <Button color="secondary" onClick={handleClose}>
              <i className="fa fa-times"></i> Cancelar
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    </div>
  );
};

export default AddUpdModal;
